import _ from "lodash";
import Echarts from "echarts";
import { calculation } from '@/method'
export default (data, id = 'chart') => {
    // 总收入
    const value1 = (calculation(
        _.get(data.find(x => x.name_code == "Total_Revenue"), 'actual'),
        _.get(data.find(x => x.name_code == "Total_Revenue"), 'budget')
    ) * 100).toFixed(2);
    setOption(value1, `${id}1`);
    // 总毛利润
    const value2 = (calculation(
        _.get(data.find(x => x.name_code == "GOP"), 'actual'),
        _.get(data.find(x => x.name_code == "GOP"), 'budget')
    ) * 100).toFixed(2);
    setOption(value2, `${id}2`, "总毛利润");
}

export const setOption = (value, id, name = "总收入") => {
    const myChart = Echarts.init(document.getElementById(id));
    var option = {
        series: [
            {
                min: 0,
                axisLine: {
                    width: 20,
                    show: true,
                    lineStyle: {
                        width: 30,
                        shadowBlur: 0,
                        color: [
                            [0.2, "#2DC6C8"],
                            [0.8, "#5AB1EF"],
                            [1, "#D87A80"],
                        ],
                    },
                },
                name: "完成率",
                type: "gauge",
                title: {
                    //标题
                    show: true,
                    offsetCenter: [0, "30%"], // x, y，单位px
                    textStyle: {
                        color: "#333",
                        fontSize: 14, //表盘上的标题文字大小
                    },
                },
                axisTick: {
                    splitNumber: 30,
                },
                detail: {
                    formatter: "{value}%",
                    offsetCenter: [0, "50%"],
                    textStyle: {
                        fontSize: 25,
                        color: "#5BB1EF",
                    },
                },
                data: [
                    {
                        value,
                        name: `${name}完成率`,
                    },
                ],
            },
        ],
    };

    myChart.setOption(option);
}


// WEBPACK FOOTER //
// ./src/components/table/other/DooBi/compute.js